import BottomAppControl from './BottomAppControl';

export default BottomAppControl;
